/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function checkfunction() {
    var check = document.getElementById("agree");
    var alert = document.getElementById("requiments-alert");
    var message = document.getElementsByClassName("ProductForm__AddToCart");
    if (check) {
        if (check.checked == true) {
            message[0].disabled = false;
            message[0].classList.remove("disabled")
            alert.style.display = "none";
        }
        else {
            alert.style.display = "block";
            message[0].classList.add("disabled")
            message[0].disabled = true;
        }
    }
}
checkfunction();
window.setTimeout(checkfunction, 500);

// window.setTimeout(checkfunction, 500);
// var scrollAlert = document.getElementById("requiments-scroll");
// const textArea = document.querySelector(".requiments-inner");
// // textArea.addEventListener("scroll", 実行したい処理(イベントハンドラ));
// var obj = document.getElementById("agree");
// var result = obj.disabled;
// // const label = document.querySelector("label");
// console.log(textArea.scrollHeight);
// if (textArea.scrollHeight < 151) {
//     obj.disabled = false;
//     scrollAlert.style.display = "none";
// };
// textArea.addEventListener("scroll", func = () => {
//     var scrolltop = Math.abs(textArea.scrollHeight - textArea.clientHeight - textArea.scrollTop);
//     if (scrolltop < 35) {
//         obj.disabled = false;
//         scrollAlert.style.display = "none";
//     };

// });



// document.querySelector(".requimentsform").onclick = function () {
//     if (obj.disabled == true) {
//         scrollAlert.style.display = "block";
//     };
// };




// function getCheckboxValue(agree) {
//     //チェック状態を取得する
//     var obj = document.getElementById("agree");
//     var result = obj.checked;
//     var alert = document.getElementById("requiments-alert");
//     var scrollAlert = document.getElementById("requiments-scroll");

//     // Alertで表示する
//     if (result) {
//         alert.style.display = "none";
//         scrollAlert.style.display = "none";
//     } else {
//         alert.style.display = "block";
//         scrollAlert.style.display = "block";
//     }
// }


// ページ読み込み時に実行
window.onload = function () {
    // 100ミリ秒ごとに非在庫チェックを実行
    setInterval("checkNonzaiko()", 100);
}

function checkNonzaiko() {
    // idがcomingCheckの要素を取得
    var obj = document.getElementById("comingCheck");
    // class名を取得
    if (obj == null) {
        return;
    }
    var className = obj.className;
    // class名にnonzaikoが含まれているかチェック
    if (className.indexOf("nonzaiko") != -1) {
        // 含まれている場合は処理を実行
        // classがProductForm__AddToCartの要素を非表示にする
        var message = document.getElementsByClassName("ProductForm__AddToCart");
        message[0].style.display = "none";
    }
}